import React from "react";
import { BACKEND_URL } from "../lib/DataSender";

function getToday() {
  var date = new Date();
  var year = date.getFullYear();
  var month = ("0" + (1 + date.getMonth())).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);

  return year + "-" + month + "-" + day;
}

function SoldierInfo({ curSolider }) {
  return (
    <div className="info01">
      <h4>상세 정보</h4>
      <div className="con_btn">
        <h1>{getToday()}</h1>
      </div>
      <div className="info_w">
        <div className="info_img">
          <img
            src={`${BACKEND_URL}/img/p/${
              curSolider.image ? curSolider.image : "profile_img.jpg"
            }`}
            alt="프로필사진"
          />
        </div>
        <div className="info_con">
          <dl>
            <dt>이름</dt>
            <dd>{curSolider.name}</dd>
            <dt>생년월일</dt>
            <dd>{curSolider.birth}</dd>
            <dt>소속</dt>
            <dd>{curSolider.army_unit?.unitName}</dd>
            <dt>군번</dt>
            <dd>{curSolider.dt_number}</dd>
            <dt>계급</dt>
            <dd>{curSolider.level}</dd>
          </dl>
        </div>
      </div>
      <ul>
        <li>
          <span>체온</span>
          {curSolider.health?.tempeture}℃
        </li>
        <li>
          <span>혈중 알코올 농도</span>
          {curSolider.health?.alcohol}%
        </li>
        <li>
          <span>심박수</span>
          {curSolider.health?.pulse}
        </li>
        <li>
          <span>복장</span>
          {curSolider.health?.garments ? "정상" : "비정상"}
        </li>
      </ul>
    </div>
  );
}

export default SoldierInfo;
